module.exports = __webpack_public_path__ + "210e7a6f02ed2c8ad7a3a26adfa909e9.svg";